import { createContext } from "react";

const ServiceMessageContext = createContext({});

export default ServiceMessageContext;
